 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"app-attach-slideshow-attach-slideshow-module-ngfactory":"app-attach-slideshow-attach-slideshow-module-ngfactory","app-company-settings-company-settings-module-ngfactory~app-get-started-get-started-module-ngfactory":"app-company-settings-company-settings-module-ngfactory~app-get-started-get-started-module-ngfactory","app-company-settings-company-settings-module-ngfactory~app-project-project-module-ngfactory":"app-company-settings-company-settings-module-ngfactory~app-project-project-module-ngfactory","common":"common","app-company-settings-company-settings-module-ngfactory":"app-company-settings-company-settings-module-ngfactory","app-get-started-get-started-module-ngfactory":"app-get-started-get-started-module-ngfactory","app-project-project-module-ngfactory":"app-project-project-module-ngfactory","app-integrations-settings-bitbucket-settings-bitbucket-settings-module-ngfactory~app-integrations-se~90bf7a3f":"app-integrations-settings-bitbucket-settings-bitbucket-settings-module-ngfactory~app-integrations-se~90bf7a3f","app-integrations-settings-bitbucket-settings-bitbucket-settings-module-ngfactory":"app-integrations-settings-bitbucket-settings-bitbucket-settings-module-ngfactory","app-integrations-settings-github-settings-github-settings-module-ngfactory":"app-integrations-settings-github-settings-github-settings-module-ngfactory","app-integrations-settings-gitlab-settings-gitlab-settings-module-ngfactory":"app-integrations-settings-gitlab-settings-gitlab-settings-module-ngfactory","app-integrations-settings-slack-alert-slack-alert-module-ngfactory":"app-integrations-settings-slack-alert-slack-alert-module-ngfactory","app-reporting-reporting-module-ngfactory":"app-reporting-reporting-module-ngfactory","app-version-version-module-ngfactory":"app-version-version-module-ngfactory","app-integrations-settings-intercom-settings-intercom-settings-module-ngfactory":"app-integrations-settings-intercom-settings-intercom-settings-module-ngfactory","app-integrations-settings-jira-settings-jira-settings-module-ngfactory":"app-integrations-settings-jira-settings-jira-settings-module-ngfactory"}[chunkId]||chunkId) + "." + {"app-attach-slideshow-attach-slideshow-module-ngfactory":"ad415d46673fcab8c963","app-company-settings-company-settings-module-ngfactory~app-get-started-get-started-module-ngfactory":"b0b09c13fdb52ae0c6e2","app-company-settings-company-settings-module-ngfactory~app-project-project-module-ngfactory":"80aed3ce2db716a4ff85","common":"8de98ce300b8753d185a","app-company-settings-company-settings-module-ngfactory":"94586facc84abeab423c","app-get-started-get-started-module-ngfactory":"7eab7117e12d19aa4a47","app-project-project-module-ngfactory":"62f2641c61f082f3818b","app-integrations-settings-bitbucket-settings-bitbucket-settings-module-ngfactory~app-integrations-se~90bf7a3f":"d4656e7694004803f71a","app-integrations-settings-bitbucket-settings-bitbucket-settings-module-ngfactory":"0757f79025dda91ddcba","app-integrations-settings-github-settings-github-settings-module-ngfactory":"a772cb9ce5488ba9b369","app-integrations-settings-gitlab-settings-gitlab-settings-module-ngfactory":"211ae27b649de50e8a14","app-integrations-settings-slack-alert-slack-alert-module-ngfactory":"43d1eee598c35b55d9d7","app-reporting-reporting-module-ngfactory":"56bc8530c5db1bd06239","app-version-version-module-ngfactory":"d1a3fbe5afb6d46df452","app-integrations-settings-intercom-settings-intercom-settings-module-ngfactory":"1bde18691f55ca5d3de0","app-integrations-settings-jira-settings-jira-settings-module-ngfactory":"93f67390f538899f7a34"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');

 				script.charset = 'utf-8';
 				script.timeout = 120;

 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				function onScriptComplete(event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
